/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTranscriptionTimeline200Response } from '../models';
/**
 * TranscriptionTimelineApi - axios parameter creator
 * @export
 */
export const TranscriptionTimelineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 文字起こしのタイムライン取得API
         * @summary 文字起こしのタイムライン取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionTimeline: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('getTranscriptionTimeline', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/timeline`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文字起こしのタイムライン生成API
         * @summary 文字起こしのタイムライン生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranscriptionSummarizeInTimeline: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('postTranscriptionSummarizeInTimeline', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/summarize_in_timeline`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranscriptionTimelineApi - functional programming interface
 * @export
 */
export const TranscriptionTimelineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranscriptionTimelineApiAxiosParamCreator(configuration)
    return {
        /**
         * 文字起こしのタイムライン取得API
         * @summary 文字起こしのタイムライン取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptionTimeline(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranscriptionTimeline200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptionTimeline(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 文字起こしのタイムライン生成API
         * @summary 文字起こしのタイムライン生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranscriptionSummarizeInTimeline(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranscriptionSummarizeInTimeline(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TranscriptionTimelineApi - factory interface
 * @export
 */
export const TranscriptionTimelineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranscriptionTimelineApiFp(configuration)
    return {
        /**
         * 文字起こしのタイムライン取得API
         * @summary 文字起こしのタイムライン取得API
         * @param {number} callResultId transcription ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionTimeline(callResultId: number, options?: any): AxiosPromise<GetTranscriptionTimeline200Response> {
            return localVarFp.getTranscriptionTimeline(callResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 文字起こしのタイムライン生成API
         * @summary 文字起こしのタイムライン生成API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranscriptionSummarizeInTimeline(callResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postTranscriptionSummarizeInTimeline(callResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranscriptionTimelineApi - interface
 * @export
 * @interface TranscriptionTimelineApi
 */
export interface TranscriptionTimelineApiInterface {
    /**
     * 文字起こしのタイムライン取得API
     * @summary 文字起こしのタイムライン取得API
     * @param {number} callResultId transcription ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionTimelineApiInterface
     */
    getTranscriptionTimeline(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetTranscriptionTimeline200Response>;

    /**
     * 文字起こしのタイムライン生成API
     * @summary 文字起こしのタイムライン生成API
     * @param {number} callResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionTimelineApiInterface
     */
    postTranscriptionSummarizeInTimeline(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getTranscriptionTimeline operation in TranscriptionTimelineApi.
 * @export
 * @interface TranscriptionTimelineApiGetTranscriptionTimelineRequest
 */
export interface TranscriptionTimelineApiGetTranscriptionTimelineRequest {
    /**
     * transcription ID
     * @type {number}
     * @memberof TranscriptionTimelineApiGetTranscriptionTimeline
     */
    readonly callResultId: number
}

/**
 * Request parameters for postTranscriptionSummarizeInTimeline operation in TranscriptionTimelineApi.
 * @export
 * @interface TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest
 */
export interface TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest {
    /**
     * 
     * @type {number}
     * @memberof TranscriptionTimelineApiPostTranscriptionSummarizeInTimeline
     */
    readonly callResultId: number
}

/**
 * TranscriptionTimelineApi - object-oriented interface
 * @export
 * @class TranscriptionTimelineApi
 * @extends {BaseAPI}
 */
export class TranscriptionTimelineApi extends BaseAPI implements TranscriptionTimelineApiInterface {
    /**
     * 文字起こしのタイムライン取得API
     * @summary 文字起こしのタイムライン取得API
     * @param {TranscriptionTimelineApiGetTranscriptionTimelineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionTimelineApi
     */
    public getTranscriptionTimeline(requestParameters: TranscriptionTimelineApiGetTranscriptionTimelineRequest, options?: AxiosRequestConfig) {
        return TranscriptionTimelineApiFp(this.configuration).getTranscriptionTimeline(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 文字起こしのタイムライン生成API
     * @summary 文字起こしのタイムライン生成API
     * @param {TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptionTimelineApi
     */
    public postTranscriptionSummarizeInTimeline(requestParameters: TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest, options?: AxiosRequestConfig) {
        return TranscriptionTimelineApiFp(this.configuration).postTranscriptionSummarizeInTimeline(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
